export const FeeApplicableTo = [
    { title: 'Products', value: 0 },
    { title: 'Services', value: 1 },
    { title: 'Both', value: 2 }
]